import { render, staticRenderFns } from "./OcorrenciasPedido.vue?vue&type=template&id=0c60e2b0&scoped=true"
import script from "./OcorrenciasPedido.vue?vue&type=script&lang=js"
export * from "./OcorrenciasPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60e2b0",
  null
  
)

export default component.exports